import FullName from './FullName';

export default interface AdditionalName extends FullName {
	type: string;
	fromDate?: string;
	toDate?: string;
}

export const createNewAdditionalName = (
	firstName = '',
	middleNames = '',
	lastName = '',
	type = '',
	fromDate: string = null,
	toDate: string = null
): AdditionalName => {
	return {
		firstName,
		middleNames,
		lastName,
		type,
		fromDate,
		toDate
	};
};
